module.exports = __webpack_public_path__ + "static/media/discount-voucher.f0855de5.svg";